import {getApi} from '@/api/utils';
import {getChangedData} from '@/utils/getChangedData';
import {withHttpError} from '@/utils/withHttpError';
import {DataProvider} from 'react-admin';
import {NavigateFunction} from 'react-router-dom';

export const getDataProvider = (navigate: NavigateFunction): DataProvider => ({
    getList: (resource, params) =>
        withHttpError(async () => {
            const api = getApi(navigate);
            return api.getList(resource, params);
        }),

    getOne: (resource, params) =>
        withHttpError(async () => {
            const api = getApi(navigate);
            const data = await api.getOne(resource, params.id);
            return {data};
        }),

    getMany: (resource, params) =>
        withHttpError(async () => {
            const api = getApi(navigate);
            const promises = params.ids.map((id) => api.getOne(resource, id));
            const results = await Promise.all(promises);
            const data = results.filter((result) => result !== null);
            return {data};
        }),

    getManyReference: async () => {
        console.warn('getManyReference has not been implemented');
        return {data: []};
    },

    create: (resource, params) =>
        withHttpError(async () => {
            const api = getApi(navigate);
            const data = {...params.data};
            delete data.id;
            const responseData = await api.create(resource, data);
            return {data: responseData};
        }),

    update: (resource, params) =>
        withHttpError(async () => {
            const api = getApi(navigate);
            const changedData = getChangedData(params.previousData, params.data);
            const data = await api.update(resource, params.id, changedData);
            return {data};
        }),

    updateMany: async () => {
        console.warn('updateMany has not been implemented');
        return {data: []};
    },

    delete: (resource, params) =>
        withHttpError(async () => {
            const api = getApi(navigate);
            const data = await api.delete(resource, params.id);
            return {data};
        }),

    deleteMany: async () => {
        console.warn('deleteMany has not been implemented');
        return {data: []};
    },
});
